// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-profile-overlay {
  position: fixed;
  inset: 0;
  /* Above fixed mobile chrome (chatbot footer / translate banner ~1001-1005),
     below cdk-overlay-container (~1100) so mat-select / mat-menu still open on top. */
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  background: rgba(15, 23, 42, 0.45);
  overflow-y: auto;
}

.edit-profile-modal {
  width: 100%;
  max-width: 560px;
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.2);
  overflow: hidden;
}

.edit-profile-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.edit-profile-modal__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #212427;
  font-family: "Poppins", sans-serif;
}

.edit-profile-modal__close {
  border: none;
  background: transparent;
  font-size: 28px;
  line-height: 1;
  color: #64748b;
  cursor: pointer;
  padding: 0 4px;
}

.edit-profile-modal__close:hover {
  color: #212427;
}

.edit-profile-modal__body {
  padding: 20px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  flex: 1 1 auto;
  min-height: 0;
}

.edit-profile-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 14px 20px;
  border-top: 1px solid #e5e7eb;
  flex-shrink: 0;
  background: #fafafa;
}

.edit-profile-avatar {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
}

.edit-profile-avatar__img {
  height: 96px;
  width: 96px;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
  border: 2px solid #e5e7eb;
}

.edit-profile-avatar__placeholder {
  font-size: 96px;
  color: #212427;
  cursor: pointer;
  line-height: 1;
}

.edit-profile-avatar__change {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #5ea1d8;
  cursor: pointer;
  position: relative;
}

.edit-profile-avatar__change input[type=file] {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

.edit-profile-avatar__upload-menu {
  padding: 8px 16px 12px;
}

.edit-profile-avatar__upload-menu p {
  margin: 0 0 8px;
  font-weight: 600;
}

.edit-profile-avatar__progress {
  width: 100%;
  max-width: 200px;
  text-align: center;
  font-size: 13px;
}

.edit-profile-section {
  margin-bottom: 24px;
}

.edit-profile-section__title {
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 600;
  color: #212427;
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}

.edit-profile-section__subtitle {
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
}

.edit-profile-section__hint {
  margin: 0 0 16px;
  font-size: 13px;
  color: #64748b;
  line-height: 1.4;
}

.edit-profile-field {
  margin-bottom: 16px;
  text-align: left;
}

.edit-profile-field__label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.edit-profile-field__label-row label {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: #212427;
}

.edit-profile-input {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 14px;
  font-size: 15px;
  color: #0d0d0d;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  transition: border-color 0.2s ease;
}

.edit-profile-input:focus {
  outline: none;
  border-color: #5ea1d8;
}

.edit-profile-input:disabled {
  background: #f3f4f6;
  color: #6b7280;
  cursor: not-allowed;
}

.edit-profile-select {
  width: 100%;
}

.edit-profile-btn {
  font-family: "Raleway", sans-serif;
  font-size: 14px;
  font-weight: 600;
  min-width: 100px;
  padding: 10px 18px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
}

.edit-profile-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.edit-profile-btn--primary {
  background-color: #5ea1d8;
  color: #fff;
}

.edit-profile-btn--primary:hover:not(:disabled) {
  background-color: #4a8fc4;
}

.edit-profile-btn--secondary {
  background: #fff;
  color: #334155;
  border: 1px solid #cbd5e1;
}

.edit-profile-btn--secondary:hover {
  background: #f8fafc;
}

.phone-input-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.country-code {
  height: 42px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  padding: 5px 8px;
  background-color: #fff;
  font-size: 14px;
  cursor: pointer;
  max-width: 45%;
}

.phone-input {
  flex-grow: 1;
}

.is-invalid {
  border: 1px solid #ef4444 !important;
  background-color: #fff1f1;
}

.alert.alert-danger {
  margin-top: 6px;
  margin-bottom: 0;
  font-size: 12px;
  text-align: left;
}

.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
  flex-shrink: 0;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 19px;
  left: 4px;
  bottom: 1px;
  background-color: white;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.slider.round {
  border-radius: 20px;
}

.slider.round:before {
  border-radius: 50%;
}

@media (max-width: 767px) {
  .edit-profile-overlay {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 0;
    align-items: stretch;
    justify-content: stretch;
    overflow: hidden;
  }
  /* Size from the fixed overlay (the visible viewport), not 100vh: in mobile browsers and
     in-app webviews 100vh includes the toolbar area and pushes the footer off-screen. */
  .edit-profile-modal {
    flex: 1 1 auto;
    max-width: none;
    height: auto;
    max-height: none;
    border-radius: 0;
    border: none;
  }
  .edit-profile-modal__header {
    padding: 12px 16px;
  }
  .edit-profile-modal__body {
    padding: 16px;
  }
  .edit-profile-modal__footer {
    padding: 12px 16px;
    padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
  }
  .edit-profile-modal__footer .edit-profile-btn {
    flex: 1 1 0;
  }
  .phone-input-container {
    flex-direction: column;
    align-items: stretch;
  }
  .country-code,
  .phone-input {
    width: 100%;
    max-width: none;
  }
}
:host-context(body.theme-dark) .edit-profile-overlay {
  background: rgba(2, 6, 23, 0.72);
}
:host-context(body.theme-dark) .edit-profile-modal,
:host-context(body.theme-dark) .edit-profile-modal__footer {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
  color: #fff;
}
:host-context(body.theme-dark) .edit-profile-modal__title,
:host-context(body.theme-dark) .edit-profile-section__title,
:host-context(body.theme-dark) .edit-profile-field__label-row label,
:host-context(body.theme-dark) .edit-profile-avatar__placeholder {
  color: #fff !important;
}
:host-context(body.theme-dark) .edit-profile-modal__close,
:host-context(body.theme-dark) .edit-profile-section__subtitle,
:host-context(body.theme-dark) .edit-profile-section__hint {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .edit-profile-input,
:host-context(body.theme-dark) .country-code {
  background: #0f172a !important;
  color: #fff !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .edit-profile-input:disabled {
  background: #1f2937 !important;
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .edit-profile-btn--primary {
  background-color: #5ea1d8 !important;
  color: #fff !important;
}
:host-context(body.theme-dark) .edit-profile-btn--secondary {
  background: #1f2937 !important;
  color: #fff !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .slider {
  background-color: #475569 !important;
}
:host-context(body.theme-dark) .slider:before {
  background-color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .is-invalid {
  border-color: #ef4444 !important;
  background-color: rgba(239, 68, 68, 0.12) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/edit-profile/edit-profile.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA;sFAAA;EAEA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,6CAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;EACA,cAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;AACF;;AAEA;EACE,YAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;EACA,iCAAA;EACA,cAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kCAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,yBAAA;EACA,WAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;EACA,yBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,oCAAA;EACA,yBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AACF;;AAEA;EACE,UAAA;EACA,QAAA;EACA,SAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE;IACE,MAAA;IACA,QAAA;IACA,SAAA;IACA,OAAA;IACA,UAAA;IACA,oBAAA;IACA,wBAAA;IACA,gBAAA;EACF;EAEA;wFAAA;EAEA;IACE,cAAA;IACA,eAAA;IACA,YAAA;IACA,gBAAA;IACA,gBAAA;IACA,YAAA;EAAF;EAGA;IACE,kBAAA;EADF;EAIA;IACE,aAAA;EAFF;EAKA;IACE,kBAAA;IACA,6DAAA;EAHF;EAMA;IACE,WAAA;EAJF;EAOA;IACE,sBAAA;IACA,oBAAA;EALF;EAQA;;IAEE,WAAA;IACA,eAAA;EANF;AACF;AAUE;EACE,gCAAA;AARJ;AAWE;;EAEE,8BAAA;EACA,kDAAA;EACA,WAAA;AATJ;AAYE;;;;EAIE,sBAAA;AAVJ;AAaE;;;EAGE,yBAAA;AAXJ;AAcE;;EAEE,8BAAA;EACA,sBAAA;EACA,kDAAA;AAZJ;AAeE;EACE,8BAAA;EACA,yBAAA;AAbJ;AAgBE;EACE,oCAAA;EACA,sBAAA;AAdJ;AAiBE;EACE,8BAAA;EACA,sBAAA;EACA,kDAAA;AAfJ;AAkBE;EACE,oCAAA;AAhBJ;AAmBE;EACE,oCAAA;AAjBJ;AAoBE;EACE,gCAAA;EACA,oDAAA;AAlBJ","sourcesContent":[".edit-profile-overlay {\n  position: fixed;\n  inset: 0;\n  /* Above fixed mobile chrome (chatbot footer / translate banner ~1001-1005),\n     below cdk-overlay-container (~1100) so mat-select / mat-menu still open on top. */\n  z-index: 1050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 16px;\n  background: rgba(15, 23, 42, 0.45);\n  overflow-y: auto;\n}\n\n.edit-profile-modal {\n  width: 100%;\n  max-width: 560px;\n  max-height: calc(100vh - 48px);\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.2);\n  overflow: hidden;\n}\n\n.edit-profile-modal__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.edit-profile-modal__title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #212427;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.edit-profile-modal__close {\n  border: none;\n  background: transparent;\n  font-size: 28px;\n  line-height: 1;\n  color: #64748b;\n  cursor: pointer;\n  padding: 0 4px;\n}\n\n.edit-profile-modal__close:hover {\n  color: #212427;\n}\n\n.edit-profile-modal__body {\n  padding: 20px;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.edit-profile-modal__footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 14px 20px;\n  border-top: 1px solid #e5e7eb;\n  flex-shrink: 0;\n  background: #fafafa;\n}\n\n.edit-profile-avatar {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 20px;\n}\n\n.edit-profile-avatar__img {\n  height: 96px;\n  width: 96px;\n  border-radius: 50%;\n  object-fit: cover;\n  cursor: pointer;\n  border: 2px solid #e5e7eb;\n}\n\n.edit-profile-avatar__placeholder {\n  font-size: 96px;\n  color: #212427;\n  cursor: pointer;\n  line-height: 1;\n}\n\n.edit-profile-avatar__change {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: #5ea1d8;\n  cursor: pointer;\n  position: relative;\n}\n\n.edit-profile-avatar__change input[type=\"file\"] {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.edit-profile-avatar__upload-menu {\n  padding: 8px 16px 12px;\n}\n\n.edit-profile-avatar__upload-menu p {\n  margin: 0 0 8px;\n  font-weight: 600;\n}\n\n.edit-profile-avatar__progress {\n  width: 100%;\n  max-width: 200px;\n  text-align: center;\n  font-size: 13px;\n}\n\n.edit-profile-section {\n  margin-bottom: 24px;\n}\n\n.edit-profile-section__title {\n  margin: 0 0 4px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #212427;\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.edit-profile-section__subtitle {\n  font-size: 13px;\n  font-weight: 500;\n  color: #64748b;\n}\n\n.edit-profile-section__hint {\n  margin: 0 0 16px;\n  font-size: 13px;\n  color: #64748b;\n  line-height: 1.4;\n}\n\n.edit-profile-field {\n  margin-bottom: 16px;\n  text-align: left;\n}\n\n.edit-profile-field__label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 6px;\n}\n\n.edit-profile-field__label-row label {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #212427;\n}\n\n.edit-profile-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 10px 14px;\n  font-size: 15px;\n  color: #0d0d0d;\n  background: #fff;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  transition: border-color 0.2s ease;\n}\n\n.edit-profile-input:focus {\n  outline: none;\n  border-color: #5ea1d8;\n}\n\n.edit-profile-input:disabled {\n  background: #f3f4f6;\n  color: #6b7280;\n  cursor: not-allowed;\n}\n\n.edit-profile-select {\n  width: 100%;\n}\n\n.edit-profile-btn {\n  font-family: \"Raleway\", sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  min-width: 100px;\n  padding: 10px 18px;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n}\n\n.edit-profile-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.edit-profile-btn--primary {\n  background-color: #5ea1d8;\n  color: #fff;\n}\n\n.edit-profile-btn--primary:hover:not(:disabled) {\n  background-color: #4a8fc4;\n}\n\n.edit-profile-btn--secondary {\n  background: #fff;\n  color: #334155;\n  border: 1px solid #cbd5e1;\n}\n\n.edit-profile-btn--secondary:hover {\n  background: #f8fafc;\n}\n\n.phone-input-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.country-code {\n  height: 42px;\n  border-radius: 8px;\n  border: 1px solid #d1d5db;\n  padding: 5px 8px;\n  background-color: #fff;\n  font-size: 14px;\n  cursor: pointer;\n  max-width: 45%;\n}\n\n.phone-input {\n  flex-grow: 1;\n}\n\n.is-invalid {\n  border: 1px solid #ef4444 !important;\n  background-color: #fff1f1;\n}\n\n.alert.alert-danger {\n  margin-top: 6px;\n  margin-bottom: 0;\n  font-size: 12px;\n  text-align: left;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 26px;\n  flex-shrink: 0;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.4s;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 23px;\n  width: 19px;\n  left: 4px;\n  bottom: 1px;\n  background-color: white;\n  transition: 0.4s;\n}\n\ninput:checked + .slider {\n  background-color: #2196f3;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #2196f3;\n}\n\ninput:checked + .slider:before {\n  transform: translateX(26px);\n}\n\n.slider.round {\n  border-radius: 20px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n\n@media (max-width: 767px) {\n  .edit-profile-overlay {\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    padding: 0;\n    align-items: stretch;\n    justify-content: stretch;\n    overflow: hidden;\n  }\n\n  /* Size from the fixed overlay (the visible viewport), not 100vh: in mobile browsers and\n     in-app webviews 100vh includes the toolbar area and pushes the footer off-screen. */\n  .edit-profile-modal {\n    flex: 1 1 auto;\n    max-width: none;\n    height: auto;\n    max-height: none;\n    border-radius: 0;\n    border: none;\n  }\n\n  .edit-profile-modal__header {\n    padding: 12px 16px;\n  }\n\n  .edit-profile-modal__body {\n    padding: 16px;\n  }\n\n  .edit-profile-modal__footer {\n    padding: 12px 16px;\n    padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));\n  }\n\n  .edit-profile-modal__footer .edit-profile-btn {\n    flex: 1 1 0;\n  }\n\n  .phone-input-container {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .country-code,\n  .phone-input {\n    width: 100%;\n    max-width: none;\n  }\n}\n\n:host-context(body.theme-dark) {\n  .edit-profile-overlay {\n    background: rgba(2, 6, 23, 0.72);\n  }\n\n  .edit-profile-modal,\n  .edit-profile-modal__footer {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n    color: #fff;\n  }\n\n  .edit-profile-modal__title,\n  .edit-profile-section__title,\n  .edit-profile-field__label-row label,\n  .edit-profile-avatar__placeholder {\n    color: #fff !important;\n  }\n\n  .edit-profile-modal__close,\n  .edit-profile-section__subtitle,\n  .edit-profile-section__hint {\n    color: #94a3b8 !important;\n  }\n\n  .edit-profile-input,\n  .country-code {\n    background: #0f172a !important;\n    color: #fff !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .edit-profile-input:disabled {\n    background: #1f2937 !important;\n    color: #94a3b8 !important;\n  }\n\n  .edit-profile-btn--primary {\n    background-color: #5ea1d8 !important;\n    color: #fff !important;\n  }\n\n  .edit-profile-btn--secondary {\n    background: #1f2937 !important;\n    color: #fff !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .slider {\n    background-color: #475569 !important;\n  }\n\n  .slider:before {\n    background-color: #e2e8f0 !important;\n  }\n\n  .is-invalid {\n    border-color: #ef4444 !important;\n    background-color: rgba(239, 68, 68, 0.12) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
